// extracted by mini-css-extract-plugin
export default {"container":"Layout-module_container_z9B6K","content":"Layout-module_content_nPjN4","form-content":"Layout-module_form-content_Rm4Z3"};